module.exports = __webpack_public_path__ + "media/images/gearguide-6b7767f6d2ecefb22ec91ea647fe06a4.svg";